import type { WsFile } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { File } from "@/store/types";

function transformWsFile(r: WsFile): File {
  return {
    id: r.id,
    contentId: r.contentId,
    url: r.url,
    mimeType: r.mimeType ?? null,
    name: r.name ?? null,
  };
}

export async function bulkUpsertFile(records: WsFile[]) {
  if (records.length === 0) return;
  store.upsert("file", records.map(transformWsFile));
}
